<template>
  <ModalComponent class="flatfinder-settings" :show="show" @close="onClose">
    <Card theme="flat" tag="form" @submit.prevent="onSubmit" class="flatfinder-settings__modal">
      <template #default>
        <h2>{{ $t('settings') }}</h2>
        <div class="col g-2">
          <InputComponent :label="$tc('changeFlatfinderReference')" required>
            <ResourceSelect
              class="elder-input__element"
              v-model="reference"
              :items="resources.fetch"
              :is-disabled="resources.isDisabled"
              search
            />
          </InputComponent>
          <InputComponent :label="$t('description')">
            <RichText v-model="form.data.description" :commands="['bold', 'italic']" />
          </InputComponent>
          <InputComponent :label="$tc('redirectUrl')" v-model="form.data.redirectUrl" />
          <InputComponent
            v-if="$path('item.reference.onModel', selected) === 'Residential'"
            :label="$t('flatfinderThumbnailType')"
          >
            <SelectComponent v-model="form.data.thumbnailType">
              <option value="cover">{{ $t('cover') }}</option>
              <option value="floorplan">{{ $tc('floorplan') }}</option>
            </SelectComponent>
          </InputComponent>
        </div>
      </template>
      <template #footer>
        <div class="row g-2 end flex-1">
          <ButtonComponent :label="$t('cancel')" @click="onClose" />
          <ButtonComponent type="submit" theme="primary" :label="$t('confirm')" :disabled="!reference" />
        </div>
      </template>
    </Card>
  </ModalComponent>
</template>

<script>
import { mergeDeepRight } from 'ramda'
import { ModalComponent } from 'vue-elder-modal'
import { InputComponent } from 'vue-elder-input'
import RichText from '@kvass/rich-text'
import Card from '@/components/Card'
import SelectComponent from '@/components/Select/Select'
import ResourceSelect from '@/components/Flatfinder/Resources/Select/Modal'

const DataTemplate = {
  reference: null,
  data: {
    description: null,
    redirectUrl: null,
    thumbnailType: 'cover',
  },
}

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    selected: Object,
    resources: Object,
  },
  watch: {
    show: {
      handler(val) {
        if (!val) return
        this.setInitialData()
      },
    },
  },
  data() {
    return {
      form: structuredClone(DataTemplate),
    }
  },
  computed: {
    reference: {
      get() {
        if (!this.form.reference) return
        return { onModel: this.form.reference.onModel, ...this.form.reference.ref }
      },
      set(val) {
        if (!val) return (this.form.reference = null)
        let { onModel, ...ref } = val

        this.form.reference = { onModel, ref }
      },
    },
  },
  methods: {
    onClose() {
      this.$emit('close')
      this.$emit('update:show', false)
    },
    onSubmit() {
      this.$emit('submit', this.form)
      this.onClose()
    },
    setInitialData() {
      this.form = mergeDeepRight(structuredClone(DataTemplate), this.selected.item)
    },
  },
  components: {
    ModalComponent,
    Card,
    SelectComponent,
    InputComponent,
    ResourceSelect,
    RichText,
  },
}
</script>

<style lang="scss">
.flatfinder-settings {
  &__modal {
    width: 100%;
    max-width: 600px;
  }
}
</style>
